module.exports = "<div class=\"component-selected\" #designerMenuElement style=\"display:none;\">\r\n  <div class=\"item-actions\">\r\n    <span (click)=\"showModal()\" class=\"btn-item-action\">\r\n      <i class=\"fa fa-pencil-alt\"></i>\r\n    </span>\r\n    <span class=\"btn-item-action\" (click)=\"removeCurrentDesigner()\">\r\n      <i class=\"fa fa-trash\"></i>\r\n    </span>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/main/designer.menu.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/main/designer.menu.component.html
// module chunks = main